const MyStory = `
So Yeah this is who I am what di I even say this is like the least fun part
about website building is like actually putting in the conent
what do I have left to do.
More info on the lammps stuf and tire stuff
on resume I can go into more detail about jobs
put my face on the hompage
creat contact page
actually fill in the about stuff
basically redo all of the poject tex
basically redo all the wording on this site
then make the task tracker app
Add the whiteboard tracker on projects
Add magicsquares on projects
Add freeflow solver on projects?
`;
function About() {
  return (
    <div>
      <h1>ABout</h1>
      <p>{MyStory}</p>
    </div>
  );
}

export default About;